import React from 'react'
import { Container, Form, Row, Col } from 'react-bootstrap'
import ModalQuit from '../ModalQuit'
import SizeFormBig from './SizeFormBig'
import RadioButtonForm from './RadioButtonForm'
import FormMaterList from './FormMaterList'
import TextareaForm from './TextareaForm'
import InputForm from './InputForm'
import AllOutIcon from '@mui/icons-material/AllOut'
import { nanoid } from 'nanoid'
import CommonAlert from './CommonAlert'
import AllModalsFooter from '../assets/AllModalsFooter'
import { MaterialsButton, SaveCurrentDataButton } from '../assets/BasicButtons'
import { createData } from './functionsForm'
import { isEqual } from 'lodash-es'

export default class FormBendPipe extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      language: 'rus',
      show: false,
      showZmey: false,
      showFason: false,
      nameForm: 'FormBendPipe',
      maxId: 20,
      dataValue: [],
      dataOnServer: [],
      dataFromServer: [],
      lengthDataFromServer: 0,
      showQuit: false,
      showContent: true,
      previousState: [],
      savedDataMessage: false,
      dataBeenSaved: false
    }

    this.doChangeValue = this.doChangeValue.bind(this)
    this.handleClickSave = this.handleClickSave.bind(this)
    this.handleClickShadow = this.handleClickShadow.bind(this)
    this.doEmpty = this.doEmpty.bind(this)
    this.doChangeVisionBlock = this.doChangeVisionBlock.bind(this)
    this.doChangeVisionBlockFason = this.doChangeVisionBlockFason.bind(this)
    this.handleClickMaterieals = this.handleClickMaterieals.bind(this)

    this.doQuitWithSave = this.doQuitWithSave.bind(this)
    this.doQuitWithoutSave = this.doQuitWithoutSave.bind(this)
    this.closeQuitModal = this.closeQuitModal.bind(this)
    this.doLoadProps = this.doLoadProps.bind(this)
    this.hideContent = this.hideContent.bind(this)
    this.setCompanyName = this.setCompanyName.bind(this)
    this.compare = this.compare.bind(this)
    this.smartWindowFunction = this.smartWindowFunction.bind(this)
    this.saveDataWithNotification = this.saveDataWithNotification.bind(this)
  }

  saveDataWithNotification() {
    this.handleClickSave()

    this.setState({
      savedDataMessage: true,
      dataBeenSaved: true
    })
    setTimeout(() => {
      this.setState({
        savedDataMessage: false
      })
    }, 2000)
  }

  hideContent() {
    this.setState({ showContent: false })
  }

  setCompanyName() {
    if (this.props.companyName && this.props.companyName.length > 0) {
      this.setState({
        companyName: this.props.companyName
      })
    }
  }

  closeQuitModal() {
    this.setState({
      showQuit: false
    })
  }

  handleClickMaterieals() {
    this.props.onRunMaterials('Four_FormBendPipe')
  }

  //* empty
  doEmpty() {}

  //*
  doChangeVisionBlock(e) {
    if (e === 'Да') {
      this.setState({ showZmey: true })
    }
    if (e === 'Нет') {
      this.setState({ showZmey: false })
    }
  }

  //*
  doChangeVisionBlockFason(e) {
    if (e === 'Да') {
      this.setState({ showFason: true })
    }
    if (e === 'Нет') {
      this.setState({ showFason: false })
    }
  }

  //запуск выхода из формы
  handleClickShadow() {
    this.setState({ showQuit: true })
  }

  //выход с сохранением
  doQuitWithSave() {
    this.setState({ showQuit: false })
    this.handleClickSave()
    this.props.onChangeView(this.state.nameForm)
  }
  //выход без сохранения
  doQuitWithoutSave() {
    this.setState({ showQuit: false })
    this.props.onChangeView(this.state.nameForm)
  }

  //*формируем данные в массив объектов для отправки на сервер
  handleClickSave() {
    let data = this.state.dataOnServer

    for (let i = 0; i <= this.state.maxId; i++) {
      //todo создаем позицию с пустым объектом
      data[i] = { id: '', fid: '', description: '', information: '', value: '' }

      //todo заполняем объект данными с сервера
      this.state.dataFromServer.forEach((dataD) => {
        if (+dataD.id === i) {
          data[i] = { id: dataD.id, fid: dataD.fid, description: dataD.description, information: dataD.information, value: dataD.value }
        }
      })
      //todo заполняем объект данными с формы
      this.state.dataValue.forEach((dataE) => {
        if (+dataE.id === i) {
          data[i] = { id: dataE.id, fid: dataE.fid, description: dataE.description, information: dataE.information, value: dataE.value }
        }
      })
    }
    this.setState({ dataOnServer: data }) //todo проверка на наличие данных на сервере
    if (this.state.lengthDataFromServer < 1) {
      console.log('CREATE DATA')
      this.props.onCreateDataServer(data, this.state.nameForm, localStorage.getItem('idUser'))
    } else {
      console.log('UPDATE DATA')
      this.props.onUpdateDataOnServer(data, this.state.nameForm, localStorage.getItem('idUser'))
    }
  }

  //* данные с полей формы, формируются в массив объектов
  doChangeValue(data) {
    this.setState({ dataValue: [...this.state.dataValue, data] })
    this.setState({
      dataBeenSaved: false
    })
  }

  async doLoadProps() {
    try {
      if (this.props.data) {
        await this.setState({
          dataFromServer: this.props.data,
          lengthDataFromServer: this.props.lengthDataFromServer,
          showZmey: this.props.data[7].value,
          showFason: this.props.data[15].value
        })
      }
    } catch (err) {
      console.log(`Ошибка загрузки данных или отсутсвие данных: `, err)
    }
  }

  compare() {
    const prev = this.state.previousState
    const curr = createData(this.state.dataOnServer, this.state.maxId, this.state.dataFromServer, this.state.dataValue)

    const isStateEqual = isEqual(prev, curr)
    if (isStateEqual) {
      return true
    }
    return false
  }

  smartWindowFunction() {
    const isStateEqual = this.compare()
    const { dataBeenSaved, dataValue } = this.state
    if (isStateEqual || dataBeenSaved || dataValue.length === 0) {
      this.props.onChangeView(this.state.nameForm)
    } else {
      this.handleClickShadow()
    }
  }

  async componentDidMount() {
    await this.doLoadProps()

    if (this.props.value) {
      this.doChangeVisionBlock(this.props.data[7].value)
      this.doChangeVisionBlockFason(this.props.data[15].value)
    }
    this.setCompanyName()

    if (this.props.data.length) {
      const previousState = JSON.parse(JSON.stringify(this.props.data))
      this.setState({ previousState })
    }
  }

  render() {
    const view = this.props.view
    this.value = this.props.data
    const viewQuest = this.props.viewQuest
    const placeholder = ['Мин диаметр трубы, мм', 'Макс диаметр трубы, мм', 'Мин радиус гиба, мм', 'Мин толщ стенки трубы, мм', 'Макс толщ стенки трубы, мм']
    const placeholderZmey = ['Мин диаметр трубы, мм', 'Макс диаметр трубы, мм', 'Мин диаметр змеевика, мм', 'Мин толщ стенки трубы, мм', 'Макс толщ стенки трубы, мм']
    const FASON = ['Уголок', 'Швелер', 'Двутавр']

    //условие по которому компонент определяет находится ли он в формате чтения
    const inReadMode = this.props.innFromUniversalTable === null || this.props.innFromUniversalTable === '' || this.props.innFromUniversalTable === undefined

    // console.log(this.state.showZmey);
    // console.log(this.props.data[7].value);
    // console.log(this.state.dataValue);

    return (
      <>
        {inReadMode && <>{this.state.showQuit ? <ModalQuit onQuitWithSave={this.doQuitWithSave} onQuitWithoutSave={this.doQuitWithoutSave} closeQuitModal={this.closeQuitModal} /> : ''}</>}

        {this.state.showContent && (
          <div className='modal_window' style={{ display: view ? 'block' : 'none' }}>
            <div
              className={viewQuest ? 'shadow_form' : 'shadow_form_off'}
              // onClick={this.handleClickShadow}
              onClick={this.smartWindowFunction}
            ></div>
            <Form className={viewQuest ? 'form_main' : 'form_main_view'}>
              <CommonAlert
                inReadMode={inReadMode}
                handleClickHeader={this.handleClickHeader}
                // handleClickShadow={this.handleClickShadow}
                handleClickShadow={this.smartWindowFunction}
                hideContent={this.hideContent}
                icon={<AllOutIcon fontSize='large' className='icon_primary' />}
                companyName={this.state.companyName}
                sectionName='Поставка гнутых труб и/или змеевиков'
              />
              <div>
                <Container className='form_container'>
                  <Form.Group>
                    <Row>
                      <Col>Размеры гнутых труб:</Col>
                    </Row>
                  </Form.Group>
                  <Form.Group>
                    <SizeFormBig
                      id={1}
                      width={2}
                      show={true}
                      value={this.value}
                      placeholder={placeholder} //кол-во позиций согласно длине массива
                      description='Гнутые трубы и змеевики'
                      fontSize={12}
                      onChangeValue={this.doChangeValue}
                      nameForm={this.state.nameForm}
                      readOnly={!inReadMode}
                    />
                  </Form.Group>
                  <Form.Group>
                    <RadioButtonForm
                      id={6}
                      width={12}
                      show={true}
                      title='Возможность термической обработки гиба труб: '
                      label1='Да'
                      label2='Нет'
                      placeholder='возможность термической обработки гиба труб'
                      description='Гнутые труби и змеевики'
                      value={this.value[6] ? this.value[6].value : ''}
                      onChangeValue={this.doChangeValue}
                      onChangeVisionBlock={this.doEmpty}
                      nameForm={this.state.nameForm}
                      readOnly={!inReadMode}
                    />
                  </Form.Group>
                  <Row className='border_bottom_underline'>&nbsp;</Row>
                  <Form.Group>
                    <RadioButtonForm
                      id={7}
                      width={12}
                      show={true}
                      title='Возможность изготовления змеевиков: '
                      label1='Да'
                      label2='Нет'
                      placeholder='Изготовление змеевиков'
                      description='Изготовление змеевиков'
                      value={this.value[7] ? this.value[7].value : ''}
                      onChangeValue={this.doChangeValue}
                      onChangeVisionBlock={this.doChangeVisionBlock}
                      nameForm={this.state.nameForm}
                      readOnly={!inReadMode}
                    />
                  </Form.Group>
                  {this.state.showZmey ? (
                    <Container>
                      <Form.Group>
                        <Row>
                          <Col>Размеры змеевиков:</Col>
                        </Row>
                      </Form.Group>
                      <Form.Group>
                        <SizeFormBig
                          id={8}
                          width={2}
                          show={true}
                          value={this.value}
                          placeholder={placeholderZmey}
                          description='Гнутые трубы и змеевики'
                          fontSize={12}
                          onChangeValue={this.doChangeValue}
                          nameForm={this.state.nameForm}
                          readOnly={!inReadMode}
                        />
                      </Form.Group>
                      <Form.Group>
                        <RadioButtonForm
                          className='pl_0'
                          id={13}
                          width={12}
                          show={true}
                          title='Возможность термической обработки змеевиков?'
                          label1='Да'
                          label2='Нет'
                          placeholder='возможность термической обработки змеевиков'
                          description='Гнутые труби и змеевики'
                          value={this.value[13] ? this.value[13].value : ''}
                          onChangeValue={this.doChangeValue}
                          onChangeVisionBlock={this.doEmpty}
                          nameForm={this.state.nameForm}
                          readOnly={!inReadMode}
                        />
                      </Form.Group>
                      <Form.Group>
                        <RadioButtonForm
                          className='pl_0'
                          id={14}
                          width={12}
                          show={true}
                          title='Проверка материалов, сварных соединений, готовых изделий методами РМК и НРМК: '
                          label1='Да'
                          label2='Нет'
                          placeholder='Проверка материалов, сварных соединений, готовых изделий методами РМК и НРМК'
                          description='Проверка материалов, сварных соединений, готовых изделий методами РМК и НРМК'
                          value={this.value[14] ? this.value[14].value : ''}
                          onChangeValue={this.doChangeValue}
                          onChangeVisionBlock={this.doEmpty}
                          nameForm={this.state.nameForm}
                          readOnly={!inReadMode}
                        />
                      </Form.Group>
                    </Container>
                  ) : (
                    ''
                  )}
                  <Row className='border_bottom_underline'>&nbsp;</Row>
                  <Form.Group>
                    <RadioButtonForm
                      id={15}
                      width={12}
                      show={true}
                      title='Возможность гибки фасонного проката:'
                      label1='Да'
                      label2='Нет'
                      placeholder='Гибка фасонного проката'
                      description='Гибка фасонного проката'
                      value={this.value[15] ? this.value[15].value : ''}
                      onChangeValue={this.doChangeValue}
                      onChangeVisionBlock={this.doChangeVisionBlockFason}
                      nameForm={this.state.nameForm}
                      readOnly={!inReadMode}
                    />
                  </Form.Group>
                  {this.state.showFason ? (
                    <Container>
                      <FormMaterList
                        name={nanoid()}
                        className='p_0'
                        id={16}
                        width={2}
                        rowView={false}
                        materials={FASON}
                        value={this.value[16] ? this.value[16].value : ''}
                        description='Фасонный прокат'
                        onChangeValue={this.doChangeValue}
                        nameForm={this.state.nameForm}
                        readOnly={!inReadMode}
                      />
                    </Container>
                  ) : (
                    ''
                  )}

                  <Form.Group>
                    {inReadMode && (
                      <>
                        <Row> &nbsp;</Row>

                        <InputForm
                          id={19}
                          width={12}
                          show={true}
                          // verify="number"
                          label={''}
                          fontSize={12}
                          placeholder='Комментарий:'
                          description={this.props.description}
                          value={this.value[19] ? this.value[19].value : ''}
                          onChangeValue={this.doChangeValue}
                          nameForm={this.state.nameForm}
                        />
                        <TextareaForm
                          id={20}
                          width={12}
                          label=''
                          description='Дополнения к данному разделу'
                          placeholder='Дополнительная информация по данному виду деятельности (оборудование, технологии, автоматизация и др.'
                          value={this.value[20] ? this.value[20].value : ''}
                          show={true}
                          rows={3}
                          onChangeValue={this.doChangeValue}
                        />
                      </>
                    )}
                    <Row> &nbsp;</Row>
                  </Form.Group>
                </Container>
                <AllModalsFooter
                  footerContent={
                    <>
                      {/* <Button variant="primary" onClick={this.handleClickMaterieals}>Используемые материалы</Button> */}
                      <MaterialsButton handleSaveClick={this.handleClickMaterieals} needDisable={false} />
                      {inReadMode && (
                        // <Button variant="success" onClick={this.handleClickSave}>Сохранить</Button>
                        //     <SaveButtonGreen
                        //     handleSaveClick={this.handleClickSave}
                        //     needDisable={false}
                        //     saveButtonText='Сохранить'
                        //   />
                        <SaveCurrentDataButton
                          handleSaveClick={this.saveDataWithNotification}
                          needDisable={false}
                          savedDataMessage={this.state.savedDataMessage}
                          buttonTextDefault={'Сохранить'}
                          buttonTextSaved={'Данные сохранены'}
                          needCustomIcon={false}
                        />
                      )}
                    </>
                  }
                />
              </div>
            </Form>
          </div>
        )}
      </>
    )
  }
}
